/**
 * Error codes the Backend returns as a 403 on a startup-scoped route when the
 * startup's own status blocks access - distinct from `ENTITY_NOT_FOUND` or a
 * plain permission failure (MYN-131 AC-4). Kept as named constants rather
 * than inline string literals, since both the check and its tests need the
 * exact value to stay in sync with the Backend contract.
 */
export const ENTITY_STATUS_ERROR_CODES = {
  SUSPENDED: 'ENTITY_SUSPENDED',
  DELETED: 'ENTITY_DELETED',
} as const;
